import { createAsyncThunk } from '@reduxjs/toolkit';
import { ToppingsCategoryItem } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchToppingsCategoryItem, FindToppingsCategoryItem, GetToppingsCategoryItem } from './interface';

export const createToppingsCategoryItem = createAsyncThunk(
  'toppingsCategoryItem/createToppingsCategoryItem',
  async (values: CreatePatchToppingsCategoryItem, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategoryItem.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const findToppingsCategoryItem = createAsyncThunk('toppingsCategoryItem/findToppingsCategoryItem', async (values: FindToppingsCategoryItem, { rejectWithValue }) => {
  try {
    const response = await ToppingsCategoryItem.find({
      query: values,
    });

    return response;
  } catch (error: any) {
    toastHandler(error);
    return rejectWithValue(error.message);
  }
});

export const getToppingsCategoryItem = createAsyncThunk(
  'toppingsCategoryItem/getToppingsCategoryItem',
  async ({ id }: GetToppingsCategoryItem, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategoryItem.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchToppingsCategoryItem = createAsyncThunk(
  'toppingsCategoryItem/patchToppingsCategoryItem',
  async ({ id, ...values }: CreatePatchToppingsCategoryItem, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategoryItem.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
